import React from 'react';
import styled from 'styled-components';
import Tooltip from '@splunk/react-ui/Tooltip';
import { variables } from '@splunk/themes';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../../common/theme/ThemeProvider';
import { react2angular } from 'react2angular';
import CircleSmall from '@splunk/react-icons/CircleSmall';

type EntityTabNotificationType = 'updated' | 'error';

interface EntityTabNotificationIndicatorProps {
    type: EntityTabNotificationType;
}

const NOTIFICATION_CONFIG: Record<EntityTabNotificationType, { tooltip: string }> = {
    updated: {
        tooltip: 'Entity type updated',
    },
    error: {
        tooltip: 'Unsupported entity type selected',
    },
};

const UpdatedDotIcon = styled(CircleSmall)`
    color: ${variables.statusColorMedium};
`;

const ErrorDotIcon = styled(CircleSmall)`
    color: ${variables.statusColorCritical};
`;

const EntityTabNotificationIndicator: React.FC<EntityTabNotificationIndicatorProps> = ({
    type,
}): JSX.Element => {
    const themeKey = useLegacyThemeServiceKey();
    const notificationConfig = NOTIFICATION_CONFIG[type];
    const DotIcon = type === 'error' ? ErrorDotIcon : UpdatedDotIcon;

    return (
        <ThemeProvider colorScheme={themeKey}>
            <Tooltip content={notificationConfig.tooltip} defaultPlacement="below">
                <DotIcon variant="filled" />
            </Tooltip>
        </ThemeProvider>
    );
};

export const entityTabNotificationIndicator = react2angular(EntityTabNotificationIndicator, [
    'type',
]);
